.component {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background-color: var(--light-grey);
}